import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostFacialBiometricConsult,
	PostFacialBiometricConsultParams,
	PostFacialBiometricConsultResponse,
} from 'domain/usecases/others/facial-biometric/request/post-facial-biometric-consult';

export class RemoteFacialBiometricConsult implements PostFacialBiometricConsult {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostFacialBiometricConsultResponse>,
	) {}

	async post(
		params: PostFacialBiometricConsultParams,
	): Promise<PostFacialBiometricConsultResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
